import { Injectable } from '@angular/core';

import { Prices, TYPE_MARKETING } from '@bytel/bytel-sales';

import { ApiPromos } from '@app/baseBtl/catalog/products/interface/context';

@Injectable({
    providedIn: 'root',
})
export class PromotionService {
    public getPromotionsByTypeMarketingFromAPI(
        typeMarketing: TYPE_MARKETING,
        withIncitation: boolean,
        promoList: ApiPromos[] = [],
    ) {
        return promoList.length > 0
            ? promoList.filter(
                  (promo) =>
                      promo?.proprietesSupplementaires?.typesMarketing &&
                      promo?.proprietesSupplementaires?.typesMarketing?.includes(typeMarketing) &&
                      (withIncitation || promo.estIncitation === withIncitation),
              )
            : [];
    }

    public filterPromotionsByTypeMarketingFromAPI(
        typeMarketing: TYPE_MARKETING,
        withIncitation: boolean,
        promoList: ApiPromos[] = [],
    ) {
        return promoList.length > 0
            ? promoList.filter(
                  (promo) =>
                      !promo?.proprietesSupplementaires?.typesMarketing?.includes(typeMarketing) &&
                      (withIncitation || promo.estIncitation === withIncitation),
              )
            : [];
    }

    public getPromotionsAmount(promoList: any[]): number {
        return promoList.reduce((acc, promotion) => acc + Number(promotion?.valeur), 0);
    }

    public getPricesWithPromos(priceIntial: number, promos: ApiPromos[], withTypeMarketing: TYPE_MARKETING[]): Prices {
        const prices: Prices = new Prices(priceIntial, priceIntial, priceIntial, 0);

        const promosPorta = this.getPromotionsByTypeMarketingFromAPI(TYPE_MARKETING.PORTABILITE, true, promos);
        const promosConvergence = this.getPromotionsByTypeMarketingFromAPI(TYPE_MARKETING.CONVERGENCE, true, promos);
        const promosNotConvergence = this.filterPromotionsByTypeMarketingFromAPI(
            TYPE_MARKETING.CONVERGENCE,
            true,
            promos,
        );
        const promosNotConverNotPorta = this.filterPromotionsByTypeMarketingFromAPI(
            TYPE_MARKETING.PORTABILITE,
            true,
            promosNotConvergence,
        );
        if (withTypeMarketing.includes(TYPE_MARKETING.PORTABILITE)) {
            prices.final -= this.getPromotionsAmount(promosPorta);
        }

        if (withTypeMarketing.includes(TYPE_MARKETING.CONVERGENCE)) {
            prices.forever -= this.getPromotionsAmount(promosConvergence);
            prices.final -= this.getPromotionsAmount(promosConvergence);
        }

        if (promosNotConverNotPorta.length > 0) {
            prices.final -= this.getPromotionsAmount(promosNotConverNotPorta);
            promosNotConverNotPorta.forEach((promo) => {
                if (promo.duree === 0) {
                    prices.forever -= this.getPromotionsAmount([promo]);
                }
            });
        }

        prices.duration = Math.max(...promos.map((promo) => promo.duree || 0));

        if (prices.final.toFixed(2) === prices.forever.toFixed(2)) {
            prices.duration = 0;
        }
        return prices;
    }

    public hasPromotionsWithAccessType(
        accessType: TYPE_MARKETING,
        withIncitation: boolean = false,
        promoList: ApiPromos[] = [],
    ): boolean {
        const promosFiltered = this.getPromotionsByTypeMarketingFromAPI(accessType, withIncitation, promoList);
        return promosFiltered.length > 0;
    }

    public findPromoFanion(objets: ApiPromos[]): string | undefined {
        for (const objet of objets) {
            if (objet.proprietesSupplementaires?.fanion) {
                return objet.proprietesSupplementaires.fanion;
            }
        }
        return undefined;
    }

    public getPricesWithPromosNotAutomatic(
        priceIntial: number,
        promos: ApiPromos[],
        withTypeMarketing: TYPE_MARKETING[],
    ): Prices {
        const prices: Prices = new Prices(priceIntial, priceIntial, priceIntial, 0);

        const promosPorta = this.getPromotionsByTypeMarketingFromAPI(TYPE_MARKETING.PORTABILITE, true, promos);
        const promosConvergence = this.getPromotionsByTypeMarketingFromAPI(TYPE_MARKETING.CONVERGENCE, true, promos);
        const promosMultiLigne = this.getPromotionsByTypeMarketingFromAPI(TYPE_MARKETING.MULTILIGNES, true, promos);
        const promosFoyer = this.getPromotionsByTypeMarketingFromAPI(TYPE_MARKETING.FOYER, false, promos);

        if (withTypeMarketing.includes(TYPE_MARKETING.PORTABILITE)) {
            prices.final -= this.getPromotionsAmount(promosPorta);
        }

        if (withTypeMarketing.includes(TYPE_MARKETING.CONVERGENCE)) {
            prices.forever -= this.getPromotionsAmount(promosConvergence);
            prices.final -= this.getPromotionsAmount(promosConvergence);
        }

        if (withTypeMarketing.includes(TYPE_MARKETING.FOYER)) {
            prices.forever -= this.getPromotionsAmount(promosFoyer);
            prices.final -= this.getPromotionsAmount(promosFoyer);
        }

        if (promosMultiLigne.length > 0) {
            prices.forever -= this.getPromotionsAmount(promosMultiLigne);
            prices.final -= this.getPromotionsAmount(promosMultiLigne);
        }

        prices.duration = Math.max(...promos.map((promo) => promo.duree || 0));

        if (prices.final.toFixed(2) === prices.forever.toFixed(2)) {
            prices.duration = 0;
        }
        return prices;
    }
}
